<template>
  <div
    class="item"
    v-if="item"
    :class="{ selected }">
    <div class="selection">
      <v-icon v-if="selected">
        fas fa-angle-right
      </v-icon>
    </div>
    <div class="item__logo">
      <v-icon
        class="item__logo"
        :class="{ 'filter__container': item.isContainer }"
        :style="`color:${item.color}`">
        {{ item.icon }}
      </v-icon>
    </div>
    <div class="item__info">
      <span
        class="item__title"
        :title="label">
        {{ label }}
      </span>
      <div
        class="item__meta"
        v-if="container">
        <span
          :title="containerLabel">
          {{ containerLabel }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    container () {
      return this.item && this.item.getContainer()
    },
    label () {
      return this.item && this.$t(this.item.translateKey(), this.item.name)
    },
    containerLabel () {
      return this.container && this.$t(this.container.translateKey(), this.container.name)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~common-assets/scss/we";

  .item {
    margin-bottom: 8px;
    height: 94px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.6rem;
    @extend .flex-row;

    &__logo {
      font-size: 40px;
      width: 100px;
      height: 100%;
      text-align: center;
      padding-top: 12px;
    }

    &__info {
      min-width: 0;
      padding-right: 24px;
      flex: 1;
      flex-basis: 0.000000001px;
    }

    &__title {
      margin: 0 0 4px 0;
      max-height: 3.2rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      font-weight: bold;
    }

    &__meta {
      span {
        margin: 8px 0;
        font-size: 1.3rem;
        font-weight: 200;
        text-align: center;
        @extend .text-no-wrap;
      }
    }

    &.selected {
      background: rgba(222, 222, 222, 0.15);
    }

    &:hover {
      background: rgba(222, 222, 222, 0.30);
    }
  }

  .selection {
    width: 15px;
    height: 100%;
    i {
      border-left:2px solid #eeeeee;
      height: 100%;
      display: flex;
    }
  }
</style>
